import { RouteRecordRaw } from 'vue-router';
import PluginsLayout from '@/components/tailwind/layout/plugins/ManagerLayout.vue';
import PluginLivesSharedWithMeLayout from '@/components/tailwind/layout/plugins/PluginLivesSharedWithMeLayout.vue';
import PluginReportLayout from '@/components/layout/plugins/PluginReportLayout.vue';
import PluginLivesLayout from '@/components/tailwind/layout/plugins/PluginLivesLayout.vue';
import PluginDashboardLayout from '@/components/tailwind/layout/plugins/PluginDashboardLayout.vue';
import InstagramLiveReportLayout from '@/components/tailwind/layout/plugins/instagram/InstagramLiveReportLayout.vue';
import FacebookLiveReportLayout from '@/components/tailwind/layout/plugins/facebook/FacebookLiveReportLayout.vue';
import InstagramLiveReportSharedWithMeLayout from '@/components/tailwind/layout/plugins/instagram/InstagramLiveReportSharedWithMeLayout.vue';
import FacebookLiveReportSharedWithMeLayout from '@/components/tailwind/layout/plugins/facebook/FacebookLiveReportSharedWithMeLayout.vue';
import NoHeaderLayout from '@/components/layout/NoHeaderLayout.vue';

const pluginsRoutes: Array<RouteRecordRaw> = [
  {
    path: '/plugins',
    name: 'PluginsManagerPage',
    meta: {
      label: 'PluginsPage',
      layout: PluginsLayout,
      accessWithSession: true,
      useTailwind: true,
    },
    component: () => import(/* webpackChunkName: "plugins" */ '@/views/tailwind/plugins/ManagerView.vue'),
  },
  {
    path: '/plugins/callback/shopify',
    name: 'PluginsCallbackShopifyPage',
    meta: {
      label: 'PluginsPage',
      layout: NoHeaderLayout,
      accessWithSession: true,
      useTailwind: true,
    },
    component: () => import(/* webpackChunkName: "plugins" */ '@/views/plugins/ShopifyCallback.vue'),
  },
  {
    path: '/plugins/callback/instagram',
    name: 'PluginsCallbackInstagramPage',
    meta: {
      label: 'PluginsPage',
      layout: NoHeaderLayout,
      accessWithSession: undefined,
      useTailwind: true,
    },
    component: () => import(/* webpackChunkName: "plugins" */ '@/views/tailwind/plugins/InstagramCallback.vue'),
  },
  {
    path: '/plugins/callback/facebook',
    name: 'PluginsCallbackFacebookPage',
    meta: {
      label: 'PluginsPage',
      layout: NoHeaderLayout,
      accessWithSession: undefined,
      useTailwind: true,
    },
    component: () => import(/* webpackChunkName: "plugins" */ '@/views/tailwind/plugins/FacebookCallback.vue'),
  },
  {
    path: '/plugins/:account/reports',
    name: 'PluginsReportPage',
    meta: {
      label: 'ReportsPage',
      layout: PluginReportLayout,
      accessWithSession: true,
      useTailwind: false,
    },
    component: () => import(/* webpackChunkName: "plugins" */ '@/views/plugins/PluginReportPage.vue'),
  },
  {
    path: '/plugins/v2/lives/share-with-me',
    name: 'PluginLivesSharedWithMePage',
    meta: {
      label: 'ReportsPage',
      layout: PluginLivesSharedWithMeLayout,
      accessWithSession: true,
      useTailwind: true,
    },
    component: () => import(/* webpackChunkName: "plugins" */ '@/views/tailwind/plugins/PluginLivesSharedWithmeView.vue'),
  },
  {
    path: '/plugins/v2/:pluginId/:pluginType',
    name: 'PluginDashboardPage',
    beforeEnter: (to) => {
      if (to.params.pluginType === 'facebook') {
        return { name: 'PluginLivesPage', params: to.params, query: to.query };
      }
      return true;
    },
    meta: {
      label: 'PluginDashboardPage',
      layout: PluginDashboardLayout,
      accessWithSession: true,
      useTailwind: true,
    },
    component: () => import(/* webpackChunkName: "plugins" */ '@/views/tailwind/plugins/PluginDashboardView.vue'),
  },
  {
    path: '/plugins/v2/:pluginId/:pluginType/bio',
    name: 'PluginBioManagerPage',
    meta: {
      label: 'PluginBioManagerPage',
      layout: PluginDashboardLayout,
      accessWithSession: true,
      useTailwind: true,
    },
    component: () => import(/* webpackChunkName: "plugins" */ '@/views/tailwind/plugins/PluginBioManagerView.vue'),
  },
  {
    // Automações: a full-page editor with its own sub-tab router
    // (Product Matching / Keywords / Data Collection). Same Layout
    // as Bio so the plugin is hydrated before the view mounts.
    path: '/plugins/v2/:pluginId/:pluginType/automacoes',
    name: 'PluginAutomacoesPage',
    meta: {
      label: 'PluginAutomacoesPage',
      layout: PluginDashboardLayout,
      accessWithSession: true,
      useTailwind: true,
    },
    component: () => import(/* webpackChunkName: "plugins" */ '@/views/tailwind/plugins/PluginAutomacoesView.vue'),
  },
  {
    path: '/plugins/v2/:pluginId/:pluginType/lives',
    name: 'PluginLivesPage',
    meta: {
      label: 'ReportsPage',
      layout: PluginLivesLayout,
      accessWithSession: true,
      useTailwind: true,
    },
    component: () => import(/* webpackChunkName: "plugins" */ '@/views/tailwind/plugins/PluginLivesView.vue'),
  },
  {
    path: '/plugins/v2/:pluginId/instagram/:accountId/medias/:mediaId/report',
    name: 'InstagramLiveReportPage',
    meta: {
      label: 'ReportsPage',
      layout: InstagramLiveReportLayout,
      accessWithSession: true,
      useTailwind: true,
    },
    component: () => import(/* webpackChunkName: "plugins-instagram" */ '@/views/tailwind/plugins/instagram/InstagramLiveReportView.vue'),
  },
  {
    path: '/plugins/v2/:pluginId/facebook/:accountId/medias/:mediaId/report',
    name: 'FacebookLiveReportPage',
    meta: {
      label: 'ReportsPage',
      layout: FacebookLiveReportLayout,
      accessWithSession: true,
      useTailwind: true,
    },
    component: () => import(/* webpackChunkName: "plugins-facebook" */ '@/views/tailwind/plugins/facebook/FacebookLiveReportView.vue'),
  },
  {
    path: '/plugins/v2/:pluginId/instagram/:accountId/medias/:mediaId/report/share-with-me',
    name: 'InstagramLiveReportSharedWithMePage',
    meta: {
      label: 'ReportsPage',
      layout: InstagramLiveReportSharedWithMeLayout,
      accessWithSession: true,
      useTailwind: true,
    },
    component: () => import(/* webpackChunkName: "plugins-instagram" */ '@/views/tailwind/plugins/instagram/InstagramLiveReportSharedWithMeView.vue'),
  },
  {
    path: '/plugins/v2/:pluginId/facebook/:accountId/medias/:mediaId/report/share-with-me',
    name: 'FacebookLiveReportSharedWithMePage',
    meta: {
      label: 'ReportsPage',
      layout: FacebookLiveReportSharedWithMeLayout,
      accessWithSession: true,
      useTailwind: true,
    },
    component: () => import(/* webpackChunkName: "plugins-facebook" */ '@/views/tailwind/plugins/facebook/FacebookLiveReportSharedWithMeView.vue'),
  },
  {
    path: '/plugins/ebook',
    name: 'PluginEbookLiveSalesPage',
    meta: {
      label: 'Live Sales - Ebook',
      layout: NoHeaderLayout,
      accessWithSession: true,
      useTailwind: true,
    },
    component: () => import(/* webpackChunkName: "plugins" */ '@/components/tailwind/plugin/PluginEbookLiveSales.vue'),
  },
];

export default pluginsRoutes;
